/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) Top Nav Search Icon component.
 */
export const TopNavSearchIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M10.2406 15.6999C13.6872 15.6999 16.4812 12.857 16.4812 9.34997C16.4812 5.84298 13.6872 3 10.2406 3C6.794 3 4 5.84298 4 9.34997C4 12.857 6.794 15.6999 10.2406 15.6999Z' stroke={iconColor}
        strokeWidth='1.5' strokeMiterlimit='10' strokeLinecap='round' />
      <path d='M14.7373 14.5039L20.102 19.9998' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' strokeLinecap='round' />
    </svg>
  );
};

export default TopNavSearchIcon;
